<template>
  <div v-if="dataList.length > 0" class="my-like-slider-wrap">
    <div class="wrap">
      <p class="my-like-text">자주 보신 프로그램이에요.<br>구독하고 프로그램의 업데이트 내용을 받아보세요.</p>
      <div class="my-like-component">
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(program, index) in dataList" class="con-wrap" :key="index">
            <span class="con-img">
              <a @click.prevent="moveToPlay(program.programid)" href="#"><img
                :src="program.image | addPostfixAndUrl('180')" :alt="program.programtitle + ' 이미지'"></a>
            </span>
            <span class="my-like-check">
              <btn-zzim-with-api is-on="n" contents-type="program" :contents-id="program.programid" :index="index" :is-mypooq="true"/>
            </span>
            <span class="con-text-wrap">
              <strong class="con-tit">{{ program.programtitle }}</strong>
              <span class="con-text01">{{ program.channelname }}</span>
            </span>
          </swiper-slide>
        </swiper>
        <div class="arrow-back-left"></div>
        <div class="arrow-back-right"></div>
        <div :id="'swiper-button-prev-program'" class="swiper-button-prev"></div>
        <div :id="'swiper-button-next-program'" class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getMyviewContents } from '@/common/utils/request'
import { addPostfixAndUrl } from '@/common/utils/common'
import _ from 'lodash'
import BtnZzimWithApi from '@/components/button/BtnZzimWithApi'
import { PATH_NAME_PLAYER_VOD } from '@/common/resources/router.const'

export default {
  components: {
    BtnZzimWithApi,
    swiper,
    swiperSlide
  },
  filters: {
    addPostfixAndUrl
  },
  data () {
    return {
      dataList: [],
      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 6,
        slidesPerGroup: 6,
        nextButton: '#swiper-button-next-program',
        prevButton: '#swiper-button-prev-program',
        onTouchEnd: (swiper) => {
          this.$nextTick(() => {
            const idx = _.get(swiper, 'clickedIndex', '')
            if (idx !== '') this.moveToPlay(this.dataList[idx].programid)
          })
        }
      }
    }
  },
  methods: {
    // 중복 프로그램 제거
    deDuplicationProgram (list) {
      let programMap = {}
      list.forEach((data) => {
        if (data.programid && !(data.programid in programMap)) {
          programMap[data.programid] = data
        }
      })
      this.dataList = Object.values(programMap).slice(0, 12)
    },
    moveToPlay (programId) {
      this.$router.push({
        name: PATH_NAME_PLAYER_VOD,
        query: {
          programid: programId
        }
      })
    },
    setData () {
      getMyviewContents({ contenttype: 'vod', offset: 0, limit: 30, orderby: 'new', image: 'circle' }).then(({ data }) => {
        data.forEach((data) => {
          if (data.type === 'vodlist') {
            this.deDuplicationProgram(data.list)
          }
        })
      })
    }
  },
  created () {
    this.setData()
  }
}
</script>
